import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE,
  FETCH_INGREDIENT_KEYWORDS,
} from '../action-types'

export const cleanupFetchIngredientKeywords = createAction(
  FETCH_INGREDIENT_KEYWORDS.CLEANUP,
)

export const checkSupportingKeywordNodesForType = createPayloadAction(
  CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE,
)
